import React from "react";

type Props = { inverse?: boolean; className?: string };

/**
 * DuxTrans lockup (spec c.6): geometric mark (bowl + T) drawn as inline SVG and
 * a live-text wordmark in Inter 800. Inverse variant sits on navy without a box.
 */
const Logo: React.FC<Props> = ({ inverse = false, className = "" }) => (
  <span className={`logo${inverse ? " logo--inverse" : ""}${className ? ` ${className}` : ""}`}>
    <svg className="logo-mark" viewBox="0 0 42 36" aria-hidden="true" focusable="false">
      <path d="M13 10A13 13 0 0 0 13 36Z" />
      <rect x="16" y="0" width="10" height="36" />
      <rect x="8" y="0" width="34" height="8" />
    </svg>
    <span className="logo-word">
      <span className="logo-dux">Dux</span>
      <span className="logo-trans">Trans</span>
    </span>
  </span>
);

export default Logo;
